import React from "react";
import { Dropzone, DownloadContainer } from "../styles";
import { MdOutlineFileUpload, MdOutlineFolderOpen } from "react-icons/md";

export const SendFiles = ({ browseFiles }) => {
    return (
        <Dropzone>
            <DownloadContainer>
                <div>
                    <div className="align">
                        <MdOutlineFileUpload size={60} color="#FE8418" />
                        <span>Solte aqui seus arquivos</span>
                    </div>
                    <button className="align" onClick={browseFiles}>
                        <MdOutlineFolderOpen size={18} />
                        <span> Selecionar arquivos</span>
                    </button>
                </div>
            </DownloadContainer>
        </Dropzone>
    );
};
